<template>
  <Icon
    name="block"
    :width="15"
    :height="16"
  >
    <path d="M7.49984 0.916504C3.58984 0.916504 0.416504 4.08984 0.416504 7.99984C0.416504 11.9098 3.58984 15.0832 7.49984 15.0832C11.4098 15.0832 14.5832 11.9098 14.5832 7.99984C14.5832 4.08984 11.4098 0.916504 7.49984 0.916504ZM1.83317 7.99984C1.83317 4.869 4.369 2.33317 7.49984 2.33317C8.81025 2.33317 10.0144 2.77942 10.9707 3.53025L3.03025 11.4707C2.27942 10.5144 1.83317 9.31025 1.83317 7.99984ZM7.49984 13.6665C6.18942 13.6665 4.98525 13.2203 4.029 12.4694L11.9694 4.529C12.7203 5.48525 13.1665 6.68942 13.1665 7.99984C13.1665 11.1307 10.6307 13.6665 7.49984 13.6665Z"/>
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";
export default {
  name: "Block",

  components: { Icon },
};
</script>
